import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=228266de"
import script from "./NavTabs.vue?vue&type=script&lang=js"
export * from "./NavTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {S2TabPageHeader: require('/usr/src/app/node_modules/front-components/components/ui/tab/TabPageHeader.vue').default})
